const styles = {
  container: {
    padding: '30px',
    minHeight: '100vh',
    backgroundColor: '#f4f6f9',
    fontFamily: 'Segoe UI, sans-serif',
    transition: 'margin-left 0.3s ease',
  },
  header: {
    color: '#1B019B',
    fontWeight: '600',
    fontSize: '1.5rem',
  },
  hr: {
    width: '80px',
    border: '2px solid #1B019B',
    opacity: '1',
    margin: '10px auto',
  },
  title: {
    color: "#1B019B", 
    fontSize: "28px", 
    fontWeight: "bold", 
    marginBottom: "20px"
  },
  organisationHeader: {
    backgroundColor: '#fff', 
    padding: '20px', 
    borderRadius: '12px', 
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    marginBottom: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  tableHeader: {
    backgroundColor: '#1B019B',
    color: '#fff',
  },
  card: {
    borderRadius: '15px', 
    border: 'none'
  },
  searchBar: {
    width: '100%',
    borderRadius: '20px',
    paddingLeft: '10px',
    height: '35px',
    border: '1px solid #ccc',
    fontSize: '1rem',
  },
  selectFilter: {
    width: '100%',
    borderRadius: '20px',
    padding: '5px 15px',
    height: '35px',
    border: '1px solid #ccc',
    backgroundColor: 'white',
  },
  statsContainer: {
    backgroundColor: '#1B019B10',
    borderRadius: '15px',
    padding: '15px',
    marginBottom: '20px'
  },
  statsBadge: {
    backgroundColor: '#f8f9fa',
    color: '#1B019B',
    padding: '8px 15px',
    borderRadius: '20px',
    fontWeight: '600',
    boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
  },
  exportButton: {
    backgroundColor: '#dc3545',
    color: 'white',
    border: 'none',
    borderRadius: '20px',
    padding: '8px 16px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    transition: 'all 0.3s ease',
  },
  clearSearchButton: {
    background: 'none',
    border: 'none',
    color: '#dc3545',
    marginLeft: '-30px',
    cursor: 'pointer',
    fontSize: '1.2rem',
    padding: '0 5px',
    position: 'absolute',
    right: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 10,
  },
  photoCell: {
    textAlign: 'center', 
    padding: '8px'
  },
  photo: {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    objectFit: 'cover',
    border: '2px solid #ccc',
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    cursor: 'pointer',
  },
  defaultPhoto: {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    backgroundColor: '#eee',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    color: '#888',
    border: '2px solid #ccc',
    boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
  },
  tableCell: {
    padding: '8px',
    verticalAlign: 'middle',
  },
  motifButton: {
    background: 'none',
    border: 'none',
    color: '#1B019B',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '5px',
  },
  paginationButton: {
    backgroundColor: '#1B019B',
    color: 'white',
    border: 'none',
    margin: '0 2px',
    borderRadius: '5px',
    padding: '5px 10px',
  },
  paginationActive: {
    backgroundColor: '#0d0066',
    color: 'white',
  },
  paginationDisabled: {
    backgroundColor: '#e0e0e0',
    color: '#a0a0a0',
    cursor: 'not-allowed',
  },
  
  modalOverlay: { 
    position: "fixed", 
    top: 0, 
    left: 0, 
    width: "100vw", 
    height: "100vh", 
    backgroundColor: "rgba(0,0,0,0.5)", 
    display: "flex", 
    justifyContent: "center", 
    alignItems: "center", 
    zIndex: 1000 
  },
  modalContent: { 
    background: "#fff", 
    borderRadius: 16, 
    padding: 25, 
    maxWidth: 500, 
    width: "90%", 
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
    textAlign: "center",
    position: 'relative'
  },
  modalImage: {
    maxWidth: '100%',
    maxHeight: '400px',
    borderRadius: '8px'
  },


  closeButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    background: 'none',
    border: 'none',
    fontSize: '20px',
    cursor: 'pointer',
    color: '#555'
  },




  employeeName: {
    marginTop: '10px',
    fontWeight: '600',
    color: '#1B019B'
  },

  // modalOverlay: {
  //   position: 'fixed',
  //   top: 0,
  //   left: 0,
  //   right: 0,
  //   bottom: 0,
  //   backgroundColor: 'rgba(0, 0, 0, 0.6)',
  //   display: 'flex',
  //   justifyContent: 'center',
  //   alignItems: 'flex-start',
  //   paddingTop: '40px',       
  //   zIndex: 9999,
  //   cursor: 'pointer',
  // },
  // modalContent: {
  //   position: 'relative',
  //   backgroundColor: '#fff',
  //   padding: '16px',
  //   borderRadius: '8px',
  //   boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
  //   animation: 'fadeIn 0.3s ease-in-out',
  //   maxWidth: '320px',
  //   textAlign: 'center',
  // },
  // modalImage: {
  //   width: '100%',
  //   height: 'auto',
  //   borderRadius: '6px',
  //   marginBottom: '8px',
  // },
  // closeButton: {
  //   position: 'absolute',
  //   top: '-12px',
  //   right: '-12px',
  //   color: '#fff',
  //   fontSize: '1rem',
  //   cursor: 'pointer',
  //   backgroundColor: '#333',
  //   border: 'none',
  //   borderRadius: '50%',
  //   width: '32px',
  //   height: '32px',
  //   display: 'flex',
  //   alignItems: 'center',
  //   justifyContent: 'center',
  // },
  // employeeName: {
  //   fontSize: '1rem',
  //   fontWeight: 'bold',
  //   color: '#333',
  // },
};

export default styles;